/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPatientPHRAgreementRequestBodyTypename = "PutPatientPHRAgreementRequestBody" as const;

/**
 *
 * @export
 * @interface PutPatientPHRAgreementRequestBody
 */
export interface PutPatientPHRAgreementRequestBody {
  /**
   *
   * @type {boolean}
   * @memberof PutPatientPHRAgreementRequestBody
   */
  agreement: boolean;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPatientPHRAgreementRequestBody
   */
  readonly __typename?: string;
}

export function PutPatientPHRAgreementRequestBodyFromJSON(json: any): PutPatientPHRAgreementRequestBody {
  return PutPatientPHRAgreementRequestBodyFromJSONTyped(json, false);
}

export function PutPatientPHRAgreementRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPatientPHRAgreementRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPatientPHRAgreementRequestBodyTypename,

    agreement: json["agreement"],
  };
}

export function PutPatientPHRAgreementRequestBodyToJSON(object?: PutPatientPHRAgreementRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    agreement: value.agreement,
  };
}
